import { autoLocalePath, PREFERENCE_KEY } from './locale-policy.mjs'
export async function resolveInitialLocale(router) {
  if (window.location.pathname !== '/' || /bot|crawler|spider|headless|prerender/i.test(navigator.userAgent)) return
  let choice
  try { choice = localStorage.getItem(PREFERENCE_KEY) } catch {}
  let detected
  if (!choice && ['cheyuwu.com', 'www.cheyuwu.com'].includes(location.hostname)) {
    try {
      const response = await fetch('/api/locale', { signal: AbortSignal.timeout(900), cache: 'no-store' })
      if (response.ok) detected = (await response.json()).locale
    } catch { /* Keep the URL and rendered page when edge detection is unavailable. */ }
  }
  const path = autoLocalePath({ path: location.pathname, choice, detected })
  if (path) await router.replace({ path, query: router.currentRoute.value.query, hash: router.currentRoute.value.hash })
}
